import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "mb-3 mt-4"
}
const _hoisted_2 = { class: "w-100 form-label" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChoiceControl = _resolveComponent("ChoiceControl")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.hasIcons())
      ? (_openBlock(), _createBlock(_component_ChoiceControl, {
          key: 0,
          value: _ctx.selectedValues,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedValues = $event)),
          options: _ctx.selectOptions,
          "multi-choice": true,
          icons: _ctx.icons
        }, null, 8, ["value", "options", "icons"]))
      : (_openBlock(), _createBlock(_component_v_select, {
          key: 1,
          options: _ctx.selectOptions,
          modelValue: _ctx.selectedValues,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedValues) = $event)),
          "close-on-select": false,
          multiple: ""
        }, null, 8, ["options", "modelValue"])),
    (_ctx.isCustomValueOptionSelected())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t('form.labels.customEnumValue')) + " ", 1),
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.isInvalid()}]),
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customValue) = $event)),
              placeholder: _ctx.$t(`parameters.${_ctx.parameterId}.customValuePlaceholder`)
            }, null, 10, _hoisted_3), [
              [_vModelText, _ctx.customValue]
            ]),
            (_ctx.isInvalid() && _ctx.customValue.trim() === '')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('form.errors.customEnumValueIsBlank')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}